export default "__VITE_ASSET__DzVGXvK8__"